"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerChallengeMock = exports.startChallengeMock = void 0;
exports.startChallengeMock = {
    title: 'What an attacker could gain with a successful SQLi attack?',
    type: 'multichoice',
    points: 1000,
    lesson_points_earned: 1750,
    locale: 'en',
    data: {
        isSavedWithKeys: true,
        user_data: {
            question: 'What an attacker could gain with a successful SQLi attack?',
            answers: [
                'Execution of arbitrary code on the server',
                'Information exposure and data leakage',
                'Database manipulation',
                'All of the above',
            ],
        },
    },
};
exports.answerChallengeMock = {
    correct: true,
    points: 1000,
    user_feedback: 'All of the options mentioned are possible results of a successful SQLi attack. As a result of the attack, not only technical systems could be affected, but business systems as well.',
};
